module.exports = __webpack_public_path__ + "static/media/home.6ec63e80.svg";